import { render, staticRenderFns } from "./CARsTabela.vue?vue&type=template&id=4c73a98e&lang=pug"
import script from "./CARsTabela.vue?vue&type=script&lang=js"
export * from "./CARsTabela.vue?vue&type=script&lang=js"
import style0 from "./CARsTabela.vue?vue&type=style&index=0&id=4c73a98e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports